import './TextEllipsis.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var active = '_1mnpbqs0-3-15-1';
export var ellipsis = _7a468({defaultClassName:'_1mnpbqs1-3-15-1',variantClassNames:{truncationMode:{start:'_1mnpbqs2-3-15-1',middle:'_1mnpbqs3-3-15-1',end:'_1mnpbqs4-3-15-1'}},defaultVariants:{},compoundVariants:[]});